import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";
import SelectDesignationMultiple from "components/SelectDesignationMultiple";
import SelectLicensureBodyMultiple from "components/SelectLicensureBodyMultiple";
import SelectLocationMultiple from "components/SelectLocationMultiple";
import SelectProfessionMultiple from "components/SelectProfessionMultiple";
import { useIntl } from "react-intl";
import persistanceStore from "stores/persistanceStore";

const LicenseFilter = () => {
  const { formatMessage: t } = useIntl();
  const {
    licenseFilterDesignationIds,
    licenseFilterProfessionIds,
    licenseFilterLocationIds,
    licenseFilterLicensureBodyIds,
  } = persistanceStore.useState();

  return (
    <Accordion sx={{ mb: 1 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>{t({ id: "filtersLabel" })}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <SelectDesignationMultiple
              variant="outlined"
              value={licenseFilterDesignationIds}
              onChange={(v) =>
                persistanceStore.update((s) => {
                  s.licenseFilterDesignationIds = v;
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <SelectProfessionMultiple
              variant="outlined"
              value={licenseFilterProfessionIds}
              onChange={(v) =>
                persistanceStore.update((s) => {
                  s.licenseFilterProfessionIds = v;
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <SelectLocationMultiple
              variant="outlined"
              value={licenseFilterLocationIds}
              onChange={(v) =>
                persistanceStore.update((s) => {
                  s.licenseFilterLocationIds = v;
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <SelectLicensureBodyMultiple
              variant="outlined"
              value={licenseFilterLicensureBodyIds}
              onChange={(v) =>
                persistanceStore.update((s) => {
                  s.licenseFilterLicensureBodyIds = v;
                })
              }
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default LicenseFilter;
